// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"147":"e2232f0c","692":"4356dfec"}[chunkId] + ".chunk.js";
};